 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({}[chunkId]||chunkId) + "." + {"0":"1f4f0db840172c541f42","1":"8217b4e57f25fd931cfd","2":"10b3f58bd164e879f8a9","3":"b1fb424f99d74cab417e","4":"10ee79e0108a0e25fa38","5":"0f7b9e15c4b60882753c","6":"18908b969d27bf293c4d","7":"0c39907bf0f12abbd94d","8":"5d3f211f22a4c0c53532","9":"0a7e117b34313c2a8796","10":"ac899fd4a21d808739aa","11":"3a9ba132686287ad0fd3","12":"adebb91e25abc3355ea0","13":"a8530b781ecf3cbac225","15":"f70f6feb6b3bba494f76","16":"a20ba26b833fdf5194fa","17":"f88d680589a19066211c","18":"57541018f56c39787652","19":"0a9d28eac192beb1404b","20":"9c9c9d3ce1788298f055","21":"b7834a3deb06e56bf8bc","22":"6a07527909c2a5d001bc","23":"95f1adeaf6a6f56c19e7","24":"24533ea0e4c9532599c9","25":"94347ee896dbe84f395d","26":"5c818a9071fc3ef895e2","27":"bc60953e9f18c8056474","28":"4931c99e062f50525de2","29":"666d8ecbb16acbeb0e09","30":"3d667faa818218645cd2","31":"cf060e27aca64641112a","32":"37329f1184744f3c7a52","33":"da76b11687dbd9cfbab4","34":"353f08b753c8753a5b66","35":"6da90295f80a0ea79d90","36":"b3778aae74fc6e8f1ac5","37":"aa14ba0b5791745aefcf","38":"d9d2d913413f516634b4","39":"7c5ec5820ed47421c60f","40":"15555ad3fbbda98705a7","41":"a8ed57718103656fb092","42":"19ce316ad7350a940c75","43":"2e235548cd67764cd2b1","44":"a74f9b6f54ce335f5855","45":"3df2326179d5dd28df69","46":"403b5339f7cfcf432ac0","47":"5e54c1d955e5de502321","48":"7f0c5fd216596d95c591","49":"9476980dbddada6855d9","50":"6c6aa2ef58e8a03655b9","51":"6c7ae98688819d25b60c","52":"dea4d8550ef1a508b128","53":"e7415600c042f0d546d8","54":"18f02d42632a12b2bb1a","55":"d2326493abcf55b0e4a1","56":"39186ed80e878d7d7c51","57":"c2dfb9c49a04d2713b1d","58":"5445cadf624e260e07a4","59":"c52faa129745e4cbc4df","60":"bff0714695ed826ce532","61":"08228ec68f17e68600cd","62":"2a2f750b22f454e8caf7","63":"d3545fa9a4629441b825","64":"82b5769183449076dc8a","65":"e8d52f31b76c1852318b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"15":1,"17":1,"18":1,"19":1,"23":1,"24":1,"26":1,"35":1,"38":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({}[chunkId]||chunkId) + "." + {"0":"1f4f0db840172c541f42","1":"8217b4e57f25fd931cfd","2":"10b3f58bd164e879f8a9","3":"b1fb424f99d74cab417e","4":"10ee79e0108a0e25fa38","5":"0f7b9e15c4b60882753c","6":"18908b969d27bf293c4d","7":"0c39907bf0f12abbd94d","8":"5d3f211f22a4c0c53532","9":"0a7e117b34313c2a8796","10":"ac899fd4a21d808739aa","11":"3a9ba132686287ad0fd3","12":"adebb91e25abc3355ea0","13":"a8530b781ecf3cbac225","15":"f70f6feb6b3bba494f76","16":"a20ba26b833fdf5194fa","17":"f88d680589a19066211c","18":"57541018f56c39787652","19":"0a9d28eac192beb1404b","20":"9c9c9d3ce1788298f055","21":"b7834a3deb06e56bf8bc","22":"6a07527909c2a5d001bc","23":"95f1adeaf6a6f56c19e7","24":"24533ea0e4c9532599c9","25":"94347ee896dbe84f395d","26":"5c818a9071fc3ef895e2","27":"bc60953e9f18c8056474","28":"4931c99e062f50525de2","29":"666d8ecbb16acbeb0e09","30":"3d667faa818218645cd2","31":"cf060e27aca64641112a","32":"37329f1184744f3c7a52","33":"da76b11687dbd9cfbab4","34":"353f08b753c8753a5b66","35":"6da90295f80a0ea79d90","36":"b3778aae74fc6e8f1ac5","37":"aa14ba0b5791745aefcf","38":"d9d2d913413f516634b4","39":"7c5ec5820ed47421c60f","40":"15555ad3fbbda98705a7","41":"a8ed57718103656fb092","42":"19ce316ad7350a940c75","43":"2e235548cd67764cd2b1","44":"a74f9b6f54ce335f5855","45":"3df2326179d5dd28df69","46":"403b5339f7cfcf432ac0","47":"5e54c1d955e5de502321","48":"7f0c5fd216596d95c591","49":"9476980dbddada6855d9","50":"6c6aa2ef58e8a03655b9","51":"6c7ae98688819d25b60c","52":"dea4d8550ef1a508b128","53":"e7415600c042f0d546d8","54":"18f02d42632a12b2bb1a","55":"d2326493abcf55b0e4a1","56":"39186ed80e878d7d7c51","57":"c2dfb9c49a04d2713b1d","58":"5445cadf624e260e07a4","59":"c52faa129745e4cbc4df","60":"bff0714695ed826ce532","61":"08228ec68f17e68600cd","62":"2a2f750b22f454e8caf7","63":"d3545fa9a4629441b825","64":"82b5769183449076dc8a","65":"e8d52f31b76c1852318b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "Scripts/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	(function() { /* Start undefined extensions */
 			function mix(dest, src) { // eslint-disable-line no-unused-vars
 				for(var n in src) dest[n] = src[n];
 				return dest;
 			}

 			function toUrl(name, referenceModule) {
 				return loaderScope.require.toUrl(name, referenceModule);
 			}

 			function toAbsMid(name, referenceModule) {
 				return loaderScope.require.toAbsMid(name, referenceModule);
 			}

 			// dojo require function.
 			function req(config, dependencies, callback) {
 				return contextRequire(config, dependencies, callback, 0, req);
 			};

 			function createContextRequire(moduleId) { // eslint-disable-line no-unused-vars
 				if (req.absMidsById[moduleId]) {
 					moduleId = req.absMidsById[moduleId];
 				}
 				if (!moduleId) return req;
 				var result = function(a1, a2, a3) {
 					return contextRequire(a1, a2, a3, moduleId, req);
 				};
 				for (var p in req) {
 					if (req.hasOwnProperty(p)) {
 						result[p] = req[p];
 					}
 				}
 				result.toUrl = function(name) {
 					return toUrl(name, moduleId ? {mid: moduleId} : null);
 				};
 				result.toAbsMid = function(name) {
 					return toAbsMid(name, moduleId ? {mid: moduleId} : null);
 				};

 				if (req.undef) {
 					result.undef = function(mid) {
 						req.undef(mid, moduleId);
 					};
 				}
 				return result;
 			}

 			function registerAbsMids(absMids) { // eslint-disable-line no-unused-vars
 				for (var s in absMids) {
 					req.absMids[s] = absMids[s];
 					if (!req.absMidsById[absMids[s]]) {
 						req.absMidsById[absMids[s]] = s;
 					}
 				}
 			}

 			function resolveTernaryHasExpression(expr) { // eslint-disable-line no-unused-vars
 				// Expects an expression of the form supported by dojo/has.js loader, except that module identifiers are
 				// integers corresponding to webpack module ids.  Returns a module reference if evaluation of the expression
 				// using the currently defined features returns a module id, or else undefined.

 				var has = findModule("dojo/has", null, false);
 				var id = has.normalize(expr, function(arg){return arg;});
 				return id && __webpack_require__(id) || undefined;
 			}

 			function findModule(mid, referenceModule, noInstall, asModuleObj) {
 				mid = mid.split("!").map(function(segment) {
 					var isRelative = segment.charAt(0) === '.';
 					if(isRelative && !referenceModule){
 						return segment;
 					}
 					return toAbsMid(segment, referenceModule ? {mid: referenceModule} : null);
 				}).join("!");
 				var result;
 				if (mid in req.absMids && __webpack_require__.m[req.absMids[mid]]) {
 					if (noInstall) {
 						var module = installedModules[req.absMids[mid]];
 						result = module && module.l && (asModuleObj ? module : module.exports);
 					} else {
 						result = __webpack_require__(req.absMids[mid]);
 					}
 				}
 				if (!result) {
 					throw new Error('Module not found: ' + mid);
 				}
 				return result;
 			}

 			function dojoModuleFromWebpackModule(webpackModule) { // eslint-disable-line no-unused-vars
 				var result = {i:webpackModule.i};
 				var id = req.absMidsById[webpackModule.i];
 				if (id) {
 					result.id = id;
 				}
 				Object.defineProperty(result, "exports", {
 					get: function() { return webpackModule.exports;},
 					set: function(value) {webpackModule.exports = value;},
 					enumerable: true,
 					configurable: true
 				});
 				return result;
 			}

 			function contextRequire(a1, a2, a3, referenceModule, req) { // eslint-disable-line no-shadow
 				var type = ({}.toString).call(a1);
 				if (type === '[object String]') {
 					// a3 is passed by require calls injected into dependency arrays for dependencies specified
 					// as identifiers (vs. string literals).
 					var noInstall = !(a3 === false);
 					var m = findModule(a1, referenceModule, noInstall);
 					if (typeof m === 'object' && m.__DOJO_WEBPACK_DEFINE_PROMISE__) {
 						throw new Error('Module not found: ' + a1);
 					}
 					return m;
 				} else if (type === '[object Object]') {
 					throw new Error('Require config is not supported by WebPack');
 				}
 				if (type === '[object Array]') {
 					var modules = [], callback = a2, errors = [];
 					a1.forEach(function (mid) {
 						try {
 							modules.push(findModule(mid, referenceModule));
 						} catch (e) {
 							errors.push({mid: mid, error: e});
 						}
 					});
 					if (errors.length === 0) {
 						if (callback) {
 							if (false && isDefinePromise(modules)) { // eslint-disable-line no-undef
 								Promise.all(wrapPromises(modules)).then(function(deps) { // eslint-disable-line no-undef
 									callback.apply(this, unwrapPromises(deps)); // eslint-disable-line no-undef
 								}.bind(this)).catch(function(err){console.error(err);});
 							} else {
 								callback.apply(this, modules);
 							}
 						}
 					} else {
 						var error = new Error("findModules");
 						error.src = "dojo-webpack-plugin";
 						error.info = errors;
 						req.signal("error", error);
 					}
 					return req;
 				} else {
 					throw new Error('Unsupported require call');
 				}
 			}
 			req.toUrl = toUrl;
 			req.toAbsMid = toAbsMid;
 			req.absMids = {};
 			req.absMidsById = [];
 			req.async = 1;
 		var globalObj = this||window;
 		registerAbsMids({
 			// "../internals/global" = 0
 			// "../internals/has" = 1
 			// "../internals/well-known-symbol" = 2
 			// "../internals/fails" = 3
 			// "../internals/an-object" = 4
 			// "../internals/descriptors" = 5
 			// "../internals/is-object" = 6
 			// "../internals/create-non-enumerable-property" = 7
 			// "../internals/object-define-property" = 8
 			// "../internals/internal-state" = 9
 			// "../internals/create-property-descriptor" = 10
 			// "../internals/redefine" = 11
 			// "../internals/iterators" = 12
 			// "../internals/is-pure" = 13
 			// "../internals/to-indexed-object" = 14
 			// "../internals/get-built-in" = 15
 			// "../internals/set-to-string-tag" = 16
 			// "../internals/export" = 17
 			// "../internals/classof-raw" = 18
 			// "../internals/to-object" = 19
 			// "../internals/to-integer" = 20
 			// "../internals/require-object-coercible" = 21
 			// "../internals/shared-store" = 22
 			// "../internals/set-global" = 23
 			// "../internals/to-primitive" = 24
 			// "../internals/shared-key" = 25
 			// "../internals/hidden-keys" = 26
 			// "../internals/enum-bug-keys" = 27
 			// "../internals/object-create" = 28
 			// "../internals/get-iterator-method" = 29
 			// "../internals/indexed-object" = 30
 			// "../internals/to-length" = 31
 			// "../internals/function-bind-context" = 32
 			// "../internals/string-multibyte" = 33
 			// "../internals/inspect-source" = 34
 			// "../internals/ie8-dom-define" = 35
 			// "../internals/document-create-element" = 36
 			// "../internals/shared" = 37
 			// "../internals/uid" = 38
 			// "../internals/define-iterator" = 39
 			// "../internals/object-get-own-property-descriptor" = 40
 			// "../internals/object-property-is-enumerable" = 41
 			// "../internals/object-keys-internal" = 42
 			// "../internals/object-get-own-property-symbols" = 43
 			// "../internals/create-iterator-constructor" = 44
 			// "../internals/iterators-core" = 45
 			// "../internals/object-get-prototype-of" = 46
 			// "../internals/native-symbol" = 47
 			// "../internals/object-define-properties" = 48
 			// "../internals/object-keys" = 49
 			// "../internals/native-url" = 50
 			// "../internals/an-instance" = 51
 			// "../internals/classof" = 52
 			// "./../../webpack/buildin/global.js" = 53
 			// "core-js/modules/web.url.js" = 54
 			// "./modules/tool-url" = 55
 			// "../internals/add-to-unscopables" = 56
 			// "./utils/browser" = 57
 			// "C:\\Users\\rpilotte\\source\\repos\\Legacy-WebGIS-MVC-Controller\\MagnumOpus\\MagnumOpus\\Scripts\\src\\index.js" = 58
 			// "C:\\Users\\rpilotte\\source\\repos\\Legacy-WebGIS-MVC-Controller\\MagnumOpus\\MagnumOpus\\Scripts\\temp\\dojo\\dojo.js" = 59
 			// "./tool-url" = 60
 			// "../modules/es.string.iterator" = 61
 			// "../internals/native-weak-map" = 62
 			// "../internals/copy-constructor-properties" = 63
 			// "../internals/own-keys" = 64
 			// "../internals/path" = 65
 			// "../internals/object-get-own-property-names" = 66
 			// "../internals/array-includes" = 67
 			// "../internals/to-absolute-index" = 68
 			// "../internals/is-forced" = 69
 			// "../internals/correct-prototype-getter" = 70
 			// "../internals/engine-is-node" = 71
 			// "../internals/engine-v8-version" = 72
 			// "../internals/engine-user-agent" = 73
 			// "../internals/use-symbol-as-uid" = 74
 			// "../internals/html" = 75
 			// "../internals/object-set-prototype-of" = 76
 			// "../internals/a-possible-prototype" = 77
 			// "../internals/object-assign" = 78
 			// "../internals/array-from" = 79
 			// "../internals/a-function" = 80
 			// "../internals/call-with-safe-iteration-closing" = 81
 			// "../internals/iterator-close" = 82
 			// "../internals/is-array-iterator-method" = 83
 			// "../internals/create-property" = 84
 			// "../internals/to-string-tag-support" = 85
 			// "../internals/string-punycode-to-ascii" = 86
 			// "../modules/web.url-search-params" = 87
 			// "../modules/es.array.iterator" = 88
 			// "../internals/redefine-all" = 89
 			// "../internals/get-iterator" = 90
 		});

 		globalObj.require = req;
 			(this||window)["webpackJsonp"].registerAbsMids = registerAbsMids;

 		// expose the Dojo compatibility functions as a properties of __webpack_require__
 		if (__webpack_require__.dj) throw new Error("__webpack_require__.dj name collision.")
 		__webpack_require__.dj = {
 			r: req,
 			c: createContextRequire,
 			m: dojoModuleFromWebpackModule,
 			h: resolveTernaryHasExpression,
 		};
 		var loaderScope = Object.create(globalObj, {
 		   document:{value: globalObj.document},
 		});
 		Object.defineProperties(loaderScope, {
 		   window:{value:loaderScope},
 		   global:{value:loaderScope}
 		});
 		loaderScope.define = loaderScope.require = undefined
 		globalObj.dojoConfig = globalObj.dojoConfig || {}
 		var userConfig = mix(globalObj.dojoConfig, ({'async':true,'packages':[({'name':'gisw','location':'Shared'}),({'name':'dojo','location':'dist/dojo'}),({'name':'dijit','location':'dist/dijit'}),({'name':'dojox','location':'dist/dojox'})],'parseOnLoad':true}));
 		var defaultConfig = ({'hasCache':({'webpack':1,'host-browser':1,'dom':1,'dojo-loader':1,'dojo-has-api':1,'dojo-dom-ready-api':1,'dojo-sniff':1,'dojo-test-sniff':1,'config-deferredInstrumentation':1,'config-tlmSiblingOfDojo':1})});
 		var dojoLoader = __webpack_require__(59);
 		dojoLoader.call(loaderScope, userConfig, defaultConfig, loaderScope, loaderScope);
 		Object.keys(loaderScope.require.packs).forEach(function(key) {
 			var pkg = loaderScope.require.packs[key];
 			if ((/(^\/)|(\:)/.test(pkg.main)	// main path is absolute
 			    || pkg.main.split('/').reduce(function(acc, pathComp) {
 						if (acc < 0 || pathComp === '.') return acc;
 						return (pathComp === '..' ? --acc : ++acc);
 					}, 0) <= 0) // main path is outside package
 					&& typeof pkg.realMain === 'undefined'	// hasn't already been adjusted
 			) {
 				pkg.realMain = pkg.main;
 				pkg.main = '';
 			}
 		});
 		function toAbsMid(name, referenceModule) {
 			var absMid = loaderScope.require.originalToAbsMid(name, referenceModule);
 			if (absMid.indexOf('/') === absMid.length-1) {
 				var pkgName = absMid.substring(0, absMid.length-1);
 				var pkg = loaderScope.require.packs[pkgName];
 				if (pkg && pkg.realMain) {
 					absMid = pkgName;
 				}
 			}
 			return absMid;
 		}
 		function toUrl(name, referenceModule) {
 			var url = loaderScope.require.originalToUrl(name, referenceModule);
 			var pkg = loaderScope.require.packs[name];
 			if (pkg && pkg.realMain) {
 				var parts = url.split('?');
 				if (/(^\/)|(\:)/.test(pkg.realMain)) {
 					// absolute URL
 					parts[0] = pkg.realMain;
 				} else {
 					// relative URL
 					parts[0] = parts[0] + '/' + pkg.realMain;
 				}
 				url = parts.join('?');
 			}
 			return url;
 		}
 		loaderScope.require.originalToAbsMid = loaderScope.require.toAbsMid;
 		loaderScope.require.originalToUrl = loaderScope.require.toUrl;
 		loaderScope.require.toAbsMid = toAbsMid;
 		loaderScope.require.toUrl = toUrl;
 		['baseUrl','has','rawConfig','on','signal'].forEach(function(name) {req[name] = loaderScope.require[name]})
 		var absMidsWaiting = globalObj["webpackJsonp"].absMidsWaiting;
 		if (absMidsWaiting) {
 		   absMidsWaiting.forEach(registerAbsMids);
 		   delete globalObj["webpackJsonp"].absMidsWaiting;
 		}
 	})(); /* End undefined extensions */

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 58);
